
import { defineComponent, ref, computed, PropType } from "vue";
import { useStore } from "@/store";
import { ProductListItem } from "@/models/Product";
import InputText from "primevue/inputtext";
import { IdName } from "@/models/Product";

export default defineComponent({
  components: { InputText },
  props: {
    title: String,
    rows: {
      type: Array as PropType<IdName[]>,
      required: true,
    },
  },
  async setup(props, { emit }) {
    const searchText = ref("");
    const store = useStore();
    const products = ref<ProductListItem[]>([]);
    products.value = store.state.products;
    const outSideClick = computed(() => store.state.outSideClick);
    function onSelect(productId: number) {
      searchText.value = "";
      emit("onSelect", productId);
    }
    function changeOutSideClick(event: any) {
      emit("changeSearchText", event.target.value);
      store.commit("changeOutSideClick", true);
    }

    return {
      searchText,
      products,
      onSelect,
      outSideClick,
      changeOutSideClick,
    };
  },
});
